'use client'

import MainNav from '@/app/components/MainNav'
import BAHLookup from '@/app/components/calculators/BAHLookup'

export default function BAHLookupPage() {
  return (
    <div className="space-y-8 pb-16">
      <MainNav />
      <div className="mx-auto max-w-5xl px-6">
        <BAHLookup />
      </div>
    </div>
  )
}
